var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timer-warning"},[_c('div',{staticClass:"timer-warning__wrapper"},[_c('div',{staticClass:"title"},[_vm._v(" Session About To Timeout ")]),_c('p',[_vm._v(" You will be automatically logged out in 1 minute. "),_c('br'),_vm._v(" To remain logged in move your mouse over this window. ")])])])
}]

export { render, staticRenderFns }